import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PrivacyPoliciesRoutingModule} from './privacy-policies-routing.module';
import {PrivacyPoliciesComponent} from './privacy-policies.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbCarouselModule, NgbNavModule, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {GoogleMapsModule} from '@angular/google-maps';


@NgModule({
    declarations: [PrivacyPoliciesComponent],
    imports: [
        CommonModule,
        PrivacyPoliciesRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule,
        NgbCarouselModule,
        NgbNavModule,
        GoogleMapsModule
    ]
})
export class PrivacyPoliciesModule {
}
